import { render, staticRenderFns } from "./PerformanceView.vue?vue&type=template&id=25c7610b&scoped=true"
import script from "./PerformanceView.vue?vue&type=script&lang=js"
export * from "./PerformanceView.vue?vue&type=script&lang=js"
import style0 from "./PerformanceView.vue?vue&type=style&index=0&id=25c7610b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7610b",
  null
  
)

export default component.exports